import { message } from "antd";
import moment from "moment";
import {
  createPlan,
  createAd,
  updateAd,
  fetchRtbInventory,
  fetchPlanOption,
  fetchPackageOption,
  fetchProductInfo,
  createProductInfo,
  delProductInfo,
  updateProductInfo,
  getNOSToken,
  getNOSUrl,
  getMUSICToken,
  getPositionAdvisedPrice,
  listDynamicWords,
  searchMusicTopic,
  getAppAction,
  getInteresList,
  getAppBehaviorList,
  getDefined,
  getAdPositionData,
  createTemplate,
  templateList,
  getBidModeStatus,
  getCurrentStatus,
  getCreativeTree,
  destinationUrlRequired,
  adCreateMeuShow,
  monitorRequired,
  eventContentRequired,
  checkUrl,
  getEffectTouch,
  getCostEnsure,
  getEffectsDeep,
  getLandingPageList,
} from "../services/api";
import {
  normalizeAppBehaviorData,
  normalizeAllAppBehaviorData,
} from "../utils/utils";

export default {
  namespace: "step",

  state: {
    landingPageList: [],
    effectsDeepConstant: [],
    urlRequired: false,
    handleActCont: {
      hasActionContent: false,
      minActionContent: null,
      maxActionContent: null,
    },
    step: {
      tags: [],
    },
    isMustMonitor: false,
    tabKey: "choose",
    data: {
      dateRadio: 0,
      datePicker: moment(new Date()),
      timeRadio: "",
      billingMode: 3,
      firstStageBillingMode: undefined,
      secondStageBillingMode: undefined,
      dpDirectOpen: true,
      creativeStrategy: 1,
      appAllValue: [],
      appCheckedList: [],
      appAllOptions: [],
      targetEffect: undefined,
      targetName: undefined,
      appStoreHit: false,
      deepOcpcSwitch: 0,
      creativeCategoryId: '',
      optimizeTarget: 2,
      appFilterInstall: 'app_include',
      invocationStyle: 0,
      landingPageFactoryType: 0,
    },
    planList: [],
    packageList: [],
    suggestMinPrice: "",
    suggestMaxPrice: "",
    campaignPackagePrice: "",
    hasSuggestPrice: false,
    interesOption: [],
    willingnessPayOption: [],
    appBehaviorOptions: [],
    appAllBehaviorOptions: [],
    definedData: [],
    definedEffectNameList: [],
    positionGroup: [],
    doneRouter: null,

    // 版位信息
    flightPositionData: {},
  },

  effects: {

    *getCostEnsure({ payload }, {call}) {
      return yield call(getCostEnsure, payload);
    },

    *getEffectsDeep({ payload }, { call, put }) {
      const response = yield call(getEffectsDeep, payload);
      yield put({
        type: "setEffectDeep",
        payload: response,
      });
    },

    *fetchLangdingPageList({ payload }, { call, put }) {
      const response = yield call(getLandingPageList, payload);
      yield put({
        type: "setLangdingPageListResult",
        payload: response,
      });
    },

    *checkUrl({ payload }, {call}) {
      return yield call(checkUrl, payload);
    },

    *getCreativeTree({ _ }, { call }) {
      const response = yield call(getCreativeTree);
      return response;
    },

    *fetchDefined({ payload, callback }, { call, put }) {
      const response = yield call(getDefined);
      yield put({
        type: "getDefinedData",
        payload: response,
      });
      yield put({
        type: "getEffectNameList",
        payload: "",
      });
    },

    *getAppBehaviorList({ payload }, { call, put }) {
      const response = yield call(getAppBehaviorList);
      yield put({
        type: "getAppBehaviorListResult",
        payload: response,
      });
    },

    *getInteresList({ payload }, { call, put }) {
      const response = yield call(getInteresList);
      yield put({
        type: "changeInteresList",
        payload: response,
      });
    },
    *getAppAction({ payload, callback }, { call, put }) {
      const response = yield call(getAppAction, payload);
      callback(response);
    },

    *getPositionData({ payload }, { call, put }) {
      const { type, productTypeVO } = payload;
      const data = {
        productTypeVO,
      };
      if (type === "1") {
        const response = yield call(getAdPositionData, data);
        yield put({
          type: "positionGroup",
          payload: response,
        });
      } else {
        const response = yield call(fetchPackageOption, data);
        yield put({
          type: "loadPackage",
          payload: response,
        });
      }
    },

    *fetchPlan({ payload }, { call, put }) {
      const response = yield call(fetchPlanOption, payload);
      yield put({
        type: "loadPlan",
        payload: response,
      });
    },
    *fetchPackage({ payload }, { call, put }) {
      const response = yield call(fetchPackageOption, payload);
      yield put({
        type: "loadPackage",
        payload: response,
      });
    },
    *createPlan({ payload, callback }, { call, put }) {
      const response = yield call(createPlan, payload);
      if (response) {
        const payloadData = {
          adPlanId: response.adPlanId,
          productTypeCode: response.productType.code,
        };
        message.success("创建成功");
        callback(response);
        yield put({
          type: "saveFormData",
          payload: payloadData,
        });
      }
    },

    *createSaveFormData({ payload, callback }, { select, put }) {
      yield put({
        type: "saveFormData",
        payload,
      });
      const data = yield select((state) => state.step.data);
      callback(data);
    },

    *createTemplate({ payload }, { call }) {
      const response = yield call(createTemplate, payload);
      if (response) {
        message.success("创建成功");
      }
    },

    *templateList({ payload }, { call, put }) {
      const data = yield call(templateList, payload);
      yield put({
        type: "saveTemplateList",
        payload: data,
      });
    },

    *createAd({ payload, callback, failed }, { call, put }) {
      const response = yield call(createAd, payload);
      if (response) {
        yield put({
          type: "clear",
          payload: response,
        });
        // const adPlanId = { adPlanId: response.adPlanId }
        message.success("创建成功");
        callback();
      } else {
        failed();
      }
    },

    *updateAd({ payload, callback, failed }, { call, put }) {
      const response = yield call(updateAd, payload);
      if (response) {
        // const adPlanId = { adPlanId: response.adPlanId }
        message.success("编辑成功");
        callback();
        yield put({
          type: "clear",
        });
      } else {
        failed();
      }
    },
    *fetchRtbInventory({ payload, callback }, { call, put }) {
      const response = yield call(fetchRtbInventory, payload);
      callback(response);
    },
    *queryAdProductInfoList({ payload }, { call, put }) {
      const response = yield call(fetchProductInfo, payload);
      yield put({
        type: "loadProductInfo",
        payload: response,
      });
    },
    *createAdProductInfo({ payload, callback }, { call }) {
      const response = yield call(createProductInfo, payload);
      if (response) {
        message.success("标的物上传成功");
        callback();
      }
    },
    *deleteAdProductInfo({ payload, callback }, { call }) {
      const response = yield call(delProductInfo, payload);
      if (response) {
        message.success("删除成功");
        callback();
      }
    },
    *updateAdProductInfo({ payload, callback }, { call }) {
      const response = yield call(updateProductInfo, payload);
      if (response) {
        message.success("修改成功");
        callback();
      }
    },
    *getNOSTokenV2({ payload, callback }, { call, put }) {
      const response = yield call(getNOSToken, payload);
      if (response) {
        callback(response);
      }
    },
    *getNOSToken({ payload, callback }, { call, put }) {
      const response = yield call(getNOSToken, payload);
      if (response) {
        yield put({
          type: "loadNOSToken",
          payload: response,
        });
        callback();
      }
    },
    cleanNOSToken({ callback }, { put }) {
      put({
        type: "cleanNOSToken",
      });
      callback && callback();
    },
    *getMUSICTokenV2({ payload, callback }, { call, put }) {
      const response = yield call(getMUSICToken, payload);
      if (response) {
        callback(response);
      }
    },
    *getMUSICToken({ payload, callback }, { call, put }) {
      const response = yield call(getMUSICToken, payload);
      if (response) {
        yield put({
          type: "loadMUSICToken",
          payload: response,
        });
        callback();
      }
    },
    *getNOSUrl({ payload, callback }, { call, put }) {
      const response = yield call(getNOSUrl, payload.url, payload);
      if (response) {
        yield put({
          type: "loadNOSUrl",
          payload: response,
        });
        callback();
      }
    },
    *clearUpload({ payload, callback }, { put }) {
      yield put({
        type: "clearUploadParam",
        payload: null,
      });
      callback();
    },
    *getAdvisedPrice({ payload, callback }, { call, put }) {
      const response = yield call(getPositionAdvisedPrice, payload);
      if (response) {
        yield put({
          type: "changeAdvisedPrice",
          payload: response,
        });
      }
    },
    *getDynamicWords({ callback }, { call, put }) {
      const response = yield call(listDynamicWords);
      // console.log('list dynamic', response)
      if (response) {
        callback(response);
      }
    },
    *queryMusicTopic({ payload, callback }, { call }) {
      const response = yield call(searchMusicTopic, payload);
      if (response) {
        callback(response);
      }
    },
    *getBidModeStatus({ _ }, { call }) {
      const response = yield call(getBidModeStatus);
      return response;
    },
    *getCurrentStatus({ payload }, { call }) {
      const response = yield call(getCurrentStatus, payload);
      return response;
    },
    *destinationUrlRequired({ payload }, {call, put}) {
      const response = yield call(destinationUrlRequired, payload);
      yield put({ type: "putRequired", payload: response});
    },
    *adCreateMeuShow({ payload }, {call, put}) {
      const response = yield call(adCreateMeuShow, payload);
      yield put({ type: "putAdCreateMeuShow", payload: response});
    },
    *monitorRequired({ payload }, {call, put}) {
      const response = yield call(monitorRequired, payload);
      yield put({ type: "setMonitorRequired", payload: response});
    },
    *eventContentRequired({ payload }, {call, put}) {
      const response = yield call(eventContentRequired, payload);
      yield put({ type: "setEventContent", payload: response});
    },
    *eventContentRequiredV2({ payload }, {call, put}) {
      const response = yield call(eventContentRequired, payload);
      return response;
    },
    *getEffectTouch({ payload }, {call, put}) {
      const response = yield call(getEffectTouch, payload);
      yield put({ type: "setEffectTouch", payload: response});
    },
  },

  reducers: {
    setLangdingPageListResult(state, { payload }) {
      const data = payload.list;
      return {
        ...state,
        landingPageList: data || [],
      };
    },

    setEffectDeep(state, { payload}) {
      return {
        ...state,
        effectsDeepConstant: payload,
      }
    },
    setMonitorFlag(state, { payload}) {
      return {
        ...state,
        isMustMonitor: payload,
      }
    },
    setMonitorRequired(state, {payload}) {
      return {
        ...state,
        isMustMonitor: payload,
      }
    },
    setEventContent(state, {payload}) {
      return {
        ...state,
        flightPositionData: payload,
        handleActCont: {
          hasActionContent: payload.hasActionContent,
          minActionContent: payload.minActionContent,
          maxActionContent: payload.maxActionContent,
        },
      }
    },
    setEffectTouch(state, {payload}) {
      return {
        ...state,
        effectTouch: payload,
      }
    },
    putRequired( state, {payload}) {
      return {
        ...state,
        urlRequired: payload,
      }
    },
    putAdCreateMeuShow(state, { payload }) {
      return {
        ...state,
        adCreateMeuShow: payload.videoPlayEffectiveReackUrl,
      }
    },
    getDefinedData(state, { payload }) {
      return {
        ...state,
        definedData: payload,
      };
    },
    getEffectNameList(state, { payload }) {
      const effectList = state.definedData;
      const targetEffect = payload
        ? payload.targetEffect
        : state.data.targetEffect;
      let targetList = [];
      for (const item of effectList) {
        if (item.code === targetEffect) {
          targetList = item.list;
        }
      }
      return {
        ...state,
        definedEffectNameList: targetList,
      };
    },

    getAppBehaviorListResult(state, { payload }) {
      return {
        ...state,
        appBehaviorOptions: payload
          ? payload.map((d) => normalizeAppBehaviorData(d))
          : [],
        appAllBehaviorOptions: payload
          ? normalizeAllAppBehaviorData(payload)
          : [],
      };
    },

    positionGroup(state, { payload }) {
      return {
        ...state,
        positionGroup: payload,
        packageList: [],
      };
    },

    saveTemplateList(state, { payload }) {
      return {
        ...state,
        templateList: payload,
      };
    },

    changeInteresList(state, { payload }) {
      // 重新组装后台给List数据
      const parentData = payload.filter((item) => {
        const { code, level, parent, name } = item;
        item.label = name;
        item.value = code;
        item.key = name;
        item.children = payload.filter(
          (item) => item.parent === code && item.level === level + 1
        );
        return parent == -1 && level == 1;
      });
      return {
        ...state,
        interesOption: parentData,
      };
    },

    loadPlan(state, { payload }) {
      const planList = payload.list;
      return {
        ...state,
        planList: Array.isArray(planList) ? planList : [],
      };
    },
    loadPackage(state, { payload }) {
      const packageList = payload.list;
      return {
        ...state,
        packageList: Array.isArray(packageList) ? packageList : [],
      };
    },
    loadProductInfo(state, { payload }) {
      const productInfoList = payload.list;
      return {
        ...state,
        productInfoList: Array.isArray(productInfoList) ? productInfoList : [],
      };
    },
    loadNOSToken(state, { payload }) {
      const NOSToken = payload;
      return {
        ...state,
        NOSToken,
      };
    },
    cleanNOSToken(state) {
      return {
        ...state,
        NOSToken: "",
      };
    },
    changeAdvisedPrice(state, { payload }) {
      return {
        ...state,
        advisedPrice: payload,
        suggestMaxPrice: payload.suggestMaxPrice / 100,
        suggestMinPrice: payload.suggestMinPrice / 100,
        hasSuggestPrice: payload.hasSuggestPrice,
        campaignPackagePrice: payload.campaignPackagePrice / 100,
        minOcpcClickPrice: payload.minOcpcClickPrice / 100,
        cpmMinPrice: payload.cpmMinPriceByFen / 100,
        cpmMaxPrice: payload.cpmMaxPriceByFen / 100,
        cpcMinPrice: payload.cpcMinPriceByFen / 100,
        cpcMaxPrice: payload.cpcMaxPriceByFen / 100,
        ocpcMinPrice: payload.ocpcMinPriceByFen / 100,
        ocpcMaxPrice: payload.ocpcMaxPriceByFen / 100,
        ocpmMinPrice: payload.ocpmMinPriceByFen / 100,
        ocpmMaxPrice: payload.ocpmMaxPriceByFen / 100,
      };
    },
    loadMUSICToken(state, { payload }) {
      const MUSICToken = payload;
      return {
        ...state,
        MUSICToken,
      };
    },
    loadNOSUrl(state, { payload }) {
      const NOSUrl = payload;
      return {
        ...state,
        NOSUrl,
      };
    },

    saveFormData(state, { payload }) {
      return {
        ...state,
        data: {
          ...state.data,
          ...payload,
        },
      };
    },

    loadAdDetail(state, { payload, key }) {
      const {adDetail} = state;
      Object.assign(adDetail, { [key.adformId]: payload });
      return {
        ...state,
        adDetail,
      };
    },
    updateName(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    saveStepFormData(state, { payload }) {
      return {
        ...state,
        step: {
          ...state.step,
          ...payload,
        },
      };
    },
    saveCreativeStepFormData(state, { payload }) {
      return {
        ...state,
        step: {
          ...state.step,
          ...payload,
        },
      };
    },
    clearUploadParam(state, { payload }) {
      return {
        ...state,
        NOSToken: null,
      };
    },
    clear(state) {
      return {
        step: 0,
        tabKey: "choose",
        data: {
          dateRadio: "",
          datePicker: "",
          timeRadio: "",
          billingMode: 3,
          firstStageBillingMode: undefined,
          secondStageBillingMode: undefined,
          optimizeTarget: 2,
        },
        planList: state.planList,
        packageList: [],
        targetList: [],
        doneRouter: state.doneRouter,
      };
    },
    savePlanData(state, { payload }) {
      return {
        ...state,
        data: {
          ...state.data,
          ...payload,
        },
      };
    },
    setDoneRouter(state, { payload }) {
      return {
        ...state,
        doneRouter: payload,
      };
    },
  },
};
